(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(loadingBarConfig);

    loadingBarConfig.$inject = ['cfpLoadingBarProvider', '$provide'];

    function loadingBarConfig(cfpLoadingBarProvider, $provide) {

        cfpLoadingBarProvider.includeBar = false;

        cfpLoadingBarProvider.spinnerTemplate = '' +
                '<div class="loader-container dark">' +
                '<div class="md-preloader">' +
                '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75">' +
                '<circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/>' +
                '</svg>' +
                '</div>' +
                '</div>';

    }
})();